import { mapActions, mapGetters } from 'vuex';
import mvtDropdownList from '@/common/components/mvtdropdownlist/mvt-dropdownlist.vue';
import searchSwitchView from '@/msp/components/searchswitchview/search-switchview.vue';
import { setStorage, getStorage } from '../../../common/utilities/nojq/_localstorage.js';

var timer1 = null;
var time3 = null;
export default {
    name: 'searchFilter',
    inject: ['$eventBus'],
    components: {
        mvtDropdownList,
        searchSwitchView,
    },
    data() {
        return {
            geoInfo: {
                text: '',
                geo: null,
            },
            scrolled: false,
            openItem: null,
            filterRedesignEnabled: false,
            timer: null,
        };
    },
    methods: {
        ...mapActions('msp', ['applyFilterData']),
        open(_target, id) {
            this.openItem = id;
        },
        close() {
            this.openItem = null;
        },
        isFilterRedesignEnabled(item) {
            return this.filterRedesignEnabled && !item.id.includes('houseStates') && !item.id.includes('houseMedia');
        },
        searchFilterToggle(e, item) {
            if (item && item.expose && item.changed) {
                this.searchFilterReset(e, item);
            } else {
                this.searchFilterOpen(e, item);
            }
        },
        searchFilterOpen(e, item) {
            this.$eventBus.$emit('eventbus-searchfilter-open', e ? e.currentTarget : null, item && item.id);
        },
        searchFilterReset(e, item) {
            this.$eventBus.$emit('eventbus-searchfilter-reset', item && item.id);
        },
        saveSearch() {
            this.$eventBus.$emit('eventbus-save-search', { trigger: this.$options.name });
        },
        openPop() {
            this.$eventBus.$emit('eventbus-save-search', { trigger: this.$options.name });
            setStorage('shouldPopSaveSearch', 0);
        },
        checkPopSaveSearch() {
            if ((!this.glb.savedSearches || this.glb.savedSearches.length === 0) && !(this.glb.user && this.glb.user.id)) {
                // show pop for next hour/day/month/year by time
                var nextPopSaveSearchDialogPopTime = getStorage('nextPopSaveSearchDialogPopTime');
                var nextPopSaveSearchPopWaitTime = getStorage('nextPopSaveSearchPopWaitTime');
                var now = +new Date();
                if (!nextPopSaveSearchPopWaitTime) {
                    nextPopSaveSearchPopWaitTime = 3600000;
                }
                if (!nextPopSaveSearchDialogPopTime) {
                    nextPopSaveSearchDialogPopTime = now + nextPopSaveSearchPopWaitTime;
                    setStorage('shouldPopSaveSearch', 1);
                }
                if (nextPopSaveSearchDialogPopTime < now) {
                    setStorage('shouldPopSaveSearch', 1);
                    if (nextPopSaveSearchPopWaitTime === 3600000) {
                        nextPopSaveSearchPopWaitTime = 86400000;
                    } else if (nextPopSaveSearchPopWaitTime === 86400000) {
                        nextPopSaveSearchPopWaitTime = 604800000;
                    } else if (nextPopSaveSearchPopWaitTime === 604800000) {
                        nextPopSaveSearchPopWaitTime = 2592000000;
                    } else if (nextPopSaveSearchPopWaitTime === 2592000000) {
                        nextPopSaveSearchPopWaitTime = 31536000000;
                    }
                    nextPopSaveSearchDialogPopTime = now + nextPopSaveSearchPopWaitTime;
                }

                if (getStorage('shouldPopSaveSearch')) {
                    this.openPop();
                }
                if (nextPopSaveSearchDialogPopTime) {
                    setStorage('nextPopSaveSearchDialogPopTime', nextPopSaveSearchDialogPopTime);
                }
                if (nextPopSaveSearchPopWaitTime) {
                    setStorage('nextPopSaveSearchPopWaitTime', nextPopSaveSearchPopWaitTime);
                }
            }
        },
        resetFilter: function () {
            var resetFilter = {
                coordinates: null,
                minBed: 0,
                maxBed: 0,
                minBath: 0,
                maxBath: 0,
                soldDateRange: 0,
                minPrice: 0,
                maxPrice: 0,
                propertyType: [],
                minHouseSize: 0,
                maxHouseSize: 0,
                minLotSize: 0,
                maxLotSize: 0,
                minYearBuild: 0,
                maxYearBuild: 0,
                minDOM: 0,
                maxDOM: 0,
                maxHoa: -1,
                minHoa: -1,
                pool: 0,
                isActive: 1,
                updateNew: 0,
                propertyCriteriaOpenHouse: 0,
                updatePriceReduced: 0,
                updateVirtualTour: 0,
                updateNewConstruction: 0,
                propertyCriteriaForeclosed: 0,
                hidePending: 0,
                photos: 0,
                garage: 0,
                sort: null,
                schoolHigh: 0,
                schoolMiddle: 0,
                schoolElementary: 0,
                schoolPre: 0,
                schoolPublic: 0,
                schoolCharter: 0,
                schoolPrivate: 0,
                schoolMinRate: 1,
                schoolIncludeUnrated: 1,
                schoolId: null,
                ojoAttribute: [],
            };
            this.geoInfo.text = '';
            this.geoInfo.geo = null;
            this._updateFilter(resetFilter);
            this.$eventBus.$emit('reset-monthly-payment');
        },
        _updateFilter(param) {
            // $('#body').addClass('searching');
            this.applyFilterData(param).then((url) => {
                if (timer1) {
                    clearTimeout(timer1);
                }
                timer1 = setTimeout(() => {
                    if (time3) {
                        clearTimeout(time3);
                    }
                    time3 = setTimeout(() => {
                        this.checkPopSaveSearch();
                    }, 3000);
                    this.$router.push(url);
                }, 1000);
            });
        },

        handleScroll() {
            if (this.$refs.filterScroll.scrollLeft > 10) {
                this.scrolled = true;
                if (this.timer) {
                    clearTimeout(this.timer);
                }
                this.timer = setTimeout(() => {
                    this.scrolled = false;
                }, 1000);
            } else {
                this.scrolled = false;
            }
        },
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb', 'getTags', 'getSplit']),
        ...mapGetters('msp', ['geo', 'msp', 'getNearbyCities', 'getNearbyZipcodes', 'getNearbyNeighborhood', 'getNearbyCounties', 'noFilter']),
        filterCount() {
            let pathArr = (this.msp.viewUrl.split('/') || []).filter((val) => {
                return val.match(/p-\d+$/) || val === 'boundary-1' || val.includes('sortby-') || val.indexOf('@') === 0 ? false : !!val;
            });
            let count = pathArr.length;
            if (count && ['NEIGHBORHOOD', 'ZIPCODE'].includes(this.msp.searchType)) {
                count--;
            }
            return count - 1;
        },
        needRest() {
            return this.msp.totalCount === 0 && !this.noFilter;
        },
    },
    created() {
        this.filterRedesignEnabled = this.getSplit('movoto-msp-filter-redesign-CW-2249');
    },
    mounted() {
        this.$eventBus.$on('eventbus-resetfilter', this.resetFilter);
        this.$eventBus.$on('eventbus-updatefilter', this._updateFilter);
        this.$eventBus.$on('eventbus-searchfilter-open', this.open);
        this.$eventBus.$on('eventbus-searchfilter-close', this.close);
        //check if $el scrolled
        if (this.$refs.filterScroll) {
            this.$refs.filterScroll.addEventListener('scroll', this.handleScroll);
        }
    },
    beforeUnmount() {
        if (this.$refs.filterScroll) {
            this.$refs.filterScroll.removeEventListener('scroll', this.handleScroll);
        }
        this.$eventBus.$off('eventbus-resetfilter');
        this.$eventBus.$off('eventbus-updatefilter');
        this.$eventBus.$off('eventbus-searchfilter-open');
        this.$eventBus.$off('eventbus-searchfilter-close');
    },
};
